<template>
  <div>
    <div class="sur_box">
      <div class="sur_header">有奖调研问卷</div>
      <div class="sur_intro fx2">
        尊敬的嘉宾，感谢云游2023工博会施耐德电气线上微站，并参与此次问卷调查。期待聆听您的宝贵建议！
      </div>
      <div class="form_box">
        <el-form ref="form" :model="form">
          <el-form-item label="">
            <div
              class="check_box"
              :label="item.title"
              v-for="(item, index) in lists"
              :key="item.id"
            >
              <div class="form_title">
                <img
                  src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_circle.png"
                  alt=""
                />
                <span>{{ item.title }}</span>
              </div>
              <el-checkbox-group
                v-model="answerlist[index].answer"
                v-if="!item.isradio"
                @change="handleCheckbox"
                :max="item.max"
              >
                <el-checkbox
                  :label="val.title"
                  name="type"
                  v-for="val in item.children"
                  :key="val.id"
                ></el-checkbox>
              </el-checkbox-group>
              <el-radio-group
                v-model="answerlist[index].answer"
                v-else
                @change="handleCheckbox"
              >
                <el-radio
                  :label="val.title"
                  v-for="val in item.children"
                  :key="val.id"
                ></el-radio>
              </el-radio-group>
              <div class="line"></div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="thank">
        <img
          v-if="clientWidth > 768"
          src="https://staticdn.ht-s.cn/se/ciif/2022/survey/line_left.png"
          alt=""
        />
        <img
          v-if="clientWidth <= 768"
          src="https://staticdn.ht-s.cn/se/ciif/2022/survey/line_left_m.png"
          alt=""
        />
        <span>感谢您的参与</span>
        <img
          v-if="clientWidth > 768"
          src="https://staticdn.ht-s.cn/se/ciif/2022/survey/line_right.png"
          alt=""
        />
        <img
          v-if="clientWidth <= 768"
          src="https://staticdn.ht-s.cn/se/ciif/2022/survey/line_right_m.png"
          alt=""
        />
      </div>
      <div class="sur_btn">
        <span
          class="btn_submit"
          v-ga="{ event: 'trk', ec: 'survey', ea: 'submit', el: 'solutsions' }"
          @click="Submit"
          >提交</span
        >
      </div>
    </div>
    <Rdialog
      :isRegister="isRegister"
      :isEmail="isEmail"
      :isExamination="isExamination"
      @handleClose="handleClose"
    ></Rdialog>
  </div>
</template>

<script>
import Rdialog from "@/components/rdialog/index.vue";
export default {
  props: {
    list: {
      type: Array,
      value: [],
    },
  },
  components: {
    Rdialog,
  },
  data() {
    return {
      lists: [],
      isRegister: false,
      isEmail: false,
      isExamination: false,
      form: {},
      answerlist: [],
    };
  },
  mounted() {
    var data = this.list
    var arr = []
    for (var i = 0; i < data.length; i++) {
      arr[i] = {answer: []}
    }
    this.answerlist = arr
    this.lists = data
  },
  methods: {
    handleCheckbox(val) {
      if (!this.$store.state.islogin) {
        this.isRegister = true;
        this.isEmail = false;
        this.isExamination = false;
        for (var i = 0; i < this.answerlist.length; i++) {
          this.answerlist[i].answer = [];
        }
        return false;
      }
    },
    Submit() {
      if (!this.$store.state.islogin) {
        this.isRegister = true;
        this.isEmail = false;
        for (var i = 0; i < this.answerlist.length; i++) {
          this.answerlist[i].answer = [];
        }
        return false;
      }
      for (var j = 0; j < this.answerlist.length; j++) {
        if (this.answerlist[j].answer.length == 0) {
          this.$toast("请确保问卷填写完整");
          return false;
          break;
        }
      }
      var answerData = new Object();
      for (let m = 0; m < this.answerlist.length; m++) {
        var l = m + 1;
        if (this.answerlist[m].answer instanceof Array) {
          answerData["Answer" + l] = this.answerlist[m].answer.join(",");
        } else {
          answerData["Answer" + l] = this.answerlist[m].answer;
        }
      }
      answerData.state = 0;
      this.$emit("handleSubmit", answerData);
    },
    handleClose() {
      this.isEmail = false;
      this.isRegister = false;
      this.isExamination = false;
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>